import React from 'react'
import { Button, Form, Input, InputGroup, InputGroupAddon } from 'reactstrap'

const MAILCHIMP_ID = '4ae7d71f93'
const MAILCHIMP_URL = 'https://ellenchisa.us16.list-manage.com/subscribe'
const MAILCHIMP_U = '80505145cb9174d810cff1e7c'

export default () => (
  <Form action={ MAILCHIMP_URL } method="get">
    <input type="hidden" name="u" value={ MAILCHIMP_U } />
    <input type="hidden" name="id" value={ MAILCHIMP_ID } />
    <InputGroup size="lg">
      <Input placeholder="email address" type="email" name="EMAIL" />
      <InputGroupAddon addonType="append">
        <Button color="brand">Join our beta</Button>
      </InputGroupAddon>
    </InputGroup>
  </Form>
)



// WEBPACK FOOTER //
// ./src/components/NewsletterSubscriptionForm.js